import * as types from '../actions/actionTypes';

const initialState = {
  priceWorksheetOpened: false,
  discountsReceived: false,
  discountSections: [],
  customAddedDiscounts: [], // same as discountInterface[], but also {categoryId, uuid}
  financePercentage: "", // %
  allFinanceOptionsPopupVisible: false,
  financeCellsVisible: !!document.kvConfig.jobId, // boolean
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.TOGGLE_PRICE_WORKSHEET_OPENED:
    case types.SET_CUSTOM_ADDED_DISCOUNTS:
    case types.SET_FINANCE_PERCENTAGE:
    case types.SET_ALL_FINANCE_OPTIONS_POPUP_VISIBLE:
    case types.SET_DISCOUNT_FINANCE_CELLS_VISIBLE:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_DISCOUNT_SECTIONS:
      return Object.assign({}, state, {
        ...action.payload,
        discountsReceived: true
      });
  }

  return state;
}
